/* eslint-disable import/prefer-default-export */
export enum EVENT {
  SIGN_UP = 'sign_up', // event is tracked on the backend
  LOGIN = 'login', // event is tracked on the backend
  UPDATE_PROFILE = 'update_profile',
  LOAD_PAGE = 'load_page',
  PREVIEW = 'preview',
  PUBLISH = 'publish',
  CLICK_ADD_CUSTOM_DOMAIN_SIDEBAR = 'click_add_custom_domain_sidebar',
  CLICK_ADD_CUSTOM_DOMAIN_BEFORE_PUBLISH_DROPDOWN = 'click_add_custom_domain_before_publish_dropdown',
  CLICK_ADD_CUSTOM_DOMAIN_PUBLISH_DROPDOWN = 'click_add_custom_domain_publish_dropdown',
  ADD_CUSTOM_DOMAIN_POPUP_OPENED = 'add_custom_domain_popup_opened',
  CLICK_UPGRADE_ADD_CUSTOM_DOMAIN_POPUP = 'click_upgrade_add_custom_domain_popup',
  CLICK_PROMO_BANNER = 'click_promo_banner',
  CLICK_SECTION_TEMPLATE = 'click_section_template',
  CLICK_COLLECTION_TEMPLATE = 'click_collection_template',
  CLICK_COLLECTION_ITEM_PAGE_TEMPLATE = 'click_collection_item_page_template',
  LOAD_LOCK_SETTINGS_PAGE = 'load_lock_settings_page',
  CREATE_FORM = 'create_form',
  PUBLISH_FORM = 'publish_form',
  VIEW_SIGNUP_PAGE = 'view_signup_page',
  OPEN_CODE_INJECTION = 'open_code_injection',
  ADDED_CODE_INJECTION = 'added_code_injection',
  OPEN_CUSTOM_DOMAIN = 'open_custom_domain',
  CLICKED_STARTING_GUIDE = 'clicked_starting_guide',
  OPEN_PAGE_TEMPLATE = 'open_page_template',
  OPENED_HELP_RESOURCES = 'opened_help_resources',
  USED_HELP_RESOURCES = 'used_help_resources',
  OPEN_ANALYTICS = 'open_analytics',
  OPEN_PRODUCTS = 'open_products',
  OPEN_COLLABORATORS = 'open_collaborators',
  OPEN_SEO = 'open_seo',
  ADDED_SEO = 'added_seo',
  OPEN_FORMS = 'open_forms',
  ONBOARDING_STARTED = 'onboarding_started',
  ONBOARDING_FINISHED = 'onboarding_finished',
  OPEN_CMS = 'open_cms',
  SELECT_USER_PERSONA = 'select_user_persona',
  SELECT_PRODUCT_TYPE = 'select_product_type',
  CLAIM_LINK = 'claim_link',
  LINK_BIO_CHANGE_PAGE_SETTINGS = 'link_bio_change_page_settings',
  MINI_PLAN_OFFERED = 'mini_plan_offered',
  ADD_PREMIUM_CARD = 'add_premium_card',
  CLICK_UPGRADE_TO_MINI = 'click_upgrade_to_mini',
  CLICK_UPGRADE_TO_GROW = 'click_upgrade_to_grow',
  CHECKOUT = 'checkout',
  UPGRADE_SUCCESS = 'upgrade_success',

  AI_VIEW_USER_PROMPT = 'ai_view_user_prompt',
  AI_VIEW_THEME_SELECTION = 'ai_view_theme_selection',
  AI_VIEW_COLOR_SELECTION = 'ai_view_color_selection',
  AI_VIEW_SECTIONS_LIST = 'ai_view_sections_list',
  AI_VIEW_PREVIEW_DASHBORD = 'ai_view_preview_dashboard',
  AI_UPDATE_APPERANCE = 'ai_update_apperance',
  AI_REGENERATE_SECTIONS = 'ai_regenerate_sections',
  AI_CLICK_EDIT_BUTTON = 'ai_click_edit_button',
  AI_CLICK_PUBLISH_BUTTON = 'ai_click_publish_button',
  AI_CLICK_EXPORT_BUTTON = 'ai_click_export_button',
  AI_CLICK_EXPORT_FIGMA = 'ai_click_export_figma',
  AI_CLICK_EXPORT_FRAMER = 'ai_click_export_framer',
  AI_SUBMIT_WEBSITE_NAME = 'ai_submit_website_name',
  AI_CLICK_WEBSITE_URL = 'ai_click_website_url',
  AI_CLICK_WEBSITE_DASHBOARD = 'ai_click_website_dashboard',
}
